/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CalibrationDataOverviewDtoNewDownloadedCalibration } from './CalibrationDataOverviewDtoNewDownloadedCalibration';
import {
    CalibrationDataOverviewDtoNewDownloadedCalibrationFromJSON,
    CalibrationDataOverviewDtoNewDownloadedCalibrationFromJSONTyped,
    CalibrationDataOverviewDtoNewDownloadedCalibrationToJSON,
} from './CalibrationDataOverviewDtoNewDownloadedCalibration';
import type { CalibrationDataDto } from './CalibrationDataDto';
import {
    CalibrationDataDtoFromJSON,
    CalibrationDataDtoFromJSONTyped,
    CalibrationDataDtoToJSON,
} from './CalibrationDataDto';
import type { CalibrationDataOverviewDtoLastReportedByDevice } from './CalibrationDataOverviewDtoLastReportedByDevice';
import {
    CalibrationDataOverviewDtoLastReportedByDeviceFromJSON,
    CalibrationDataOverviewDtoLastReportedByDeviceFromJSONTyped,
    CalibrationDataOverviewDtoLastReportedByDeviceToJSON,
} from './CalibrationDataOverviewDtoLastReportedByDevice';

/**
 * 
 * @export
 * @interface CalibrationDataOverviewDto
 */
export interface CalibrationDataOverviewDto {
    /**
     * 
     * @type {CalibrationDataOverviewDtoLastReportedByDevice}
     * @memberof CalibrationDataOverviewDto
     */
    lastReportedByDevice?: CalibrationDataOverviewDtoLastReportedByDevice | null;
    /**
     * 
     * @type {CalibrationDataOverviewDtoNewDownloadedCalibration}
     * @memberof CalibrationDataOverviewDto
     */
    newDownloadedCalibration?: CalibrationDataOverviewDtoNewDownloadedCalibration | null;
    /**
     * 
     * @type {Array<CalibrationDataDto>}
     * @memberof CalibrationDataOverviewDto
     */
    existingCalibrations?: Array<CalibrationDataDto> | null;
    /**
     * 
     * @type {string}
     * @memberof CalibrationDataOverviewDto
     */
    $type?: CalibrationDataOverviewDtoTypeEnum;
}


/**
 * @export
 */
export const CalibrationDataOverviewDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDeviceComponentDtoCalibrationDataOverviewDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.CalibrationDataOverviewDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CalibrationDataOverviewDtoTypeEnum = typeof CalibrationDataOverviewDtoTypeEnum[keyof typeof CalibrationDataOverviewDtoTypeEnum];



/**
 * Check if a given object implements the CalibrationDataOverviewDto interface.
 */
export function instanceOfCalibrationDataOverviewDto(value?: unknown): value is CalibrationDataOverviewDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CalibrationDataOverviewDtoTypeEnum)[0];
}

export function CalibrationDataOverviewDtoFromJSON(json: any): CalibrationDataOverviewDto {
    return CalibrationDataOverviewDtoFromJSONTyped(json, false);
}

export function CalibrationDataOverviewDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalibrationDataOverviewDto {
    if (json == null) {
        return json;
    }
    return {
        
        'lastReportedByDevice': json['lastReportedByDevice'] == null ? undefined : CalibrationDataOverviewDtoLastReportedByDeviceFromJSON(json['lastReportedByDevice']),
        'newDownloadedCalibration': json['newDownloadedCalibration'] == null ? undefined : CalibrationDataOverviewDtoNewDownloadedCalibrationFromJSON(json['newDownloadedCalibration']),
        'existingCalibrations': json['existingCalibrations'] == null ? undefined : ((json['existingCalibrations'] as Array<any>).map(CalibrationDataDtoFromJSON)),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function CalibrationDataOverviewDtoToJSON(value?: CalibrationDataOverviewDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'lastReportedByDevice': CalibrationDataOverviewDtoLastReportedByDeviceToJSON(value['lastReportedByDevice']),
        'newDownloadedCalibration': CalibrationDataOverviewDtoNewDownloadedCalibrationToJSON(value['newDownloadedCalibration']),
        'existingCalibrations': value['existingCalibrations'] == null ? undefined : ((value['existingCalibrations'] as Array<any>).map(CalibrationDataDtoToJSON)),
        '$type': value['$type'],
    });
}

